import React from "react";
import { useSelector } from "react-redux";
import styles from "./AccountPanel.module.scss";
import { RootState } from "../../store";

// The `/profile` page of the dobrocudan.rs portal personas (advisor and
// association). The volunteer page (VolonterProfile) is all volunteer blocks
// (loyalty, bank account, signature); a portal persona gets name, e-mail and
// its own logout control, passed in by the route so the panel stays
// persona-neutral.

interface AccountPanelProps {
  logoutControl: React.ReactNode;
}

const AccountPanel: React.FC<AccountPanelProps> = ({ logoutControl }) => {
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);

  return (
    <div className={styles.panel}>
      <div className={styles.card}>
        <img
          className={styles.avatar}
          alt=""
          src="/profile.png"
          width={120}
          height={120}
        />
        <div className={styles.name}>
          {userInfo?.firstName} {userInfo?.secondName}
        </div>
        <div className={styles.email}>{userInfo?.username}</div>
        {logoutControl}
      </div>
    </div>
  );
};

export default AccountPanel;
